import { DisplayText } from "@rentiohq/web-shared/dist/components";
import styled from "@rentiohq/web-theme";

export const Title = styled(DisplayText)`
  margin-bottom: 0 !important;
`;
